import { ColDef } from 'ag-grid-community';
import { CellTypes } from '../../services/vehicles';
import { Vehicle } from '../../types/vehicle';

interface VehicleColDef<T> extends ColDef<T> {
  type: keyof typeof CellTypes;
  field: any;
  hide?: boolean;
  suppressFiltersToolPanel?: boolean;
  suppressColumnsToolPanel?: boolean;
}

const formatDateValue = (dateValue: string) => {
  if (dateValue && dateValue.length > 0) {
    return dateValue;
  }
  return '-';
};

const columnDefs: VehicleColDef<Vehicle>[] = [
  // {
  //   headerName: 'ID',
  //   field: '_id',
  //   sortable: true,
  //   width: 140,
  //   filter: 'agTextColumnFilter',
  //   type: 'Plain',
  // },
  {
    headerName: 'Failed Updates',
    field: 'failedUpdates',
    hide: true,
    type: 'Plain',
    suppressFiltersToolPanel: true,
    suppressColumnsToolPanel: true,
  },
  {
    headerName: 'Batch Number',
    field: 'batchNumber',
    sortable: true,
    width: 140,
    filter: 'agNumberColumnFilter',
    type: 'Plain',
    hide: false,
    enableRowGroup: false,
  },
  {
    headerName: 'VIN',
    field: 'vin',
    sortable: true,
    width: 160,
    filter: 'agTextColumnFilter',
    type: 'Plain',
    hide: false,
    enableRowGroup: false,
  },
  {
    headerName: 'Year',
    field: 'year',
    sortable: true,
    width: 100,
    filter: 'agTextColumnFilter',
    type: 'Plain',
    hide: false,
    enableRowGroup: true,
  },
  {
    headerName: 'Model',
    field: 'model',
    sortable: true,
    type: 'Plain',
    filter: 'agSetColumnFilter',
    width: 180,
    hide: false,
    enableRowGroup: true,
  },
  {
    headerName: 'Variant',
    field: 'variant',
    sortable: true,
    type: 'Plain',
    width: 140,
    hide: false,
    enableRowGroup: true,
  },
  {
    headerName: 'Vehicle Stage',
    field: 'vehicleStage',
    sortable: true,
    width: 140,
    type: 'Tag',
    hide: false,
    enableRowGroup: true,
  },
  {
    headerName: 'Vehicle Substage',
    field: 'vehicleSubStage',
    sortable: true,
    type: 'Plain',
    width: 160,
    hide: false,
    enableRowGroup: true,
  },
  {
    headerName: 'Category',
    field: 'category',
    sortable: true,
    type: 'Plain',
    width: 140,
    hide: false,
    enableRowGroup: true,
  },
  {
    headerName: 'Sub Category',
    field: 'subCategory',
    sortable: true,
    type: 'Plain',
    width: 180,
    hide: false,
    enableRowGroup: true,
  },
  {
    headerName: 'Current Country',
    field: 'transitCountry',
    sortable: true,
    type: 'Country',
    width: 160,
    enableRowGroup: true,
  },
  {
    headerName: 'Listing Country',
    field: 'listingCountry',
    sortable: true,
    type: 'Plain',
    width: 160,
    enableRowGroup: true,
  },
  {
    headerName: 'Homologation Country',
    field: 'country',
    sortable: true,
    type: 'Plain',
    width: 200,
    hide: false,
    enableRowGroup: true,
  },
  {
    headerName: 'Customer Name',
    field: 'customerName',
    sortable: true,
    type: 'Plain',
    width: 200,
    enableRowGroup: true,
  },
  {
    headerName: 'Exterior color',
    field: 'exteriorColor',
    sortable: true,
    type: 'Plain',
    width: 150,
    hide: true,
    enableRowGroup: true,
  },
  {
    headerName: 'Interior color',
    field: 'interiorColor',
    sortable: true,
    type: 'Plain',
    width: 150,
    hide: true,
    enableRowGroup: true,
  },
  {
    headerName: 'AMP1 Planned Broadcast Gate Date', // Name is intentionally changed as per business req
    field: 'actualBroadcastDate',
    valueGetter: (params: any) => formatDateValue(params?.data?.actualBroadcastDate),
    sortable: true,
    type: 'Plain',
    width: 180,
    hide: true,
    enableRowGroup: true,
  },
  {
    headerName: 'AMP1 Actual Factory Gate Date ',
    field: 'actualFactoryGateDate',
    valueGetter: (params: any) => formatDateValue(params?.data?.actualFactoryGateDate),
    sortable: true,
    type: 'Plain',
    width: 180,
    hide: true,
    enableRowGroup: true,
  },
  {
    headerName: 'EU Port Date',
    field: 'euPortDate',
    sortable: true,
    type: 'Plain',
    width: 150,
    enableRowGroup: true,
    hide: false,
  },
  {
    headerName: 'AMP2 Actual Factory Gate Date',
    field: 'amp2ActualFactoryGateDate',
    sortable: true,
    type: 'Plain',
    width: 200,
    hide: true,
    enableRowGroup: true,
  },
  {
    headerName: 'Factory Campaigns',
    field: 'factoryCampaignCount',
    sortable: true,
    type: 'Plain',
    width: 180,
    hide: true,
    enableRowGroup: true,
  },
  {
    headerName: 'Previous Category',
    field: 'prevAssgnChange.previousCategory',
    sortable: true,
    type: 'Plain',
    width: 200,
    hide: false,
    enableRowGroup: true,
  },
  {
    headerName: 'Previous Sub Category',
    field: 'prevAssgnChange.previousSubCategory',
    sortable: true,
    type: 'Plain',
    width: 200,
    hide: true,
    enableRowGroup: true,
  },
  {
    headerName: 'VMS Availability Status',
    field: 'vehicleSubStatus',
    sortable: true,
    type: 'Plain',
    width: 200,
    hide: false,
    enableRowGroup: true,
  },
  {
    headerName: 'Look',
    field: 'look',
    sortable: true,
    type: 'Plain',
    width: 140,
    hide: true,
    enableRowGroup: true,
  },
  {
    headerName: 'Roof',
    field: 'roof',
    sortable: true,
    type: 'Plain',
    width: 140,
    hide: true,
    enableRowGroup: true,
  },
  {
    headerName: 'Drivetrain',
    field: 'driveTrain',
    sortable: true,
    type: 'Plain',
    width: 200,
    hide: true,
    enableRowGroup: true,
  },
  {
    headerName: 'Wheels',
    field: 'wheels',
    sortable: true,
    type: 'Plain',
    width: 180,
    hide: true,
    enableRowGroup: true,
  },
  {
    headerName: 'ADAS',
    field: 'ada',
    sortable: true,
    type: 'Plain',
    width: 180,
    hide: false,
    enableRowGroup: true,
  },
  {
    headerName: 'Sound System',
    field: 'soundSystem',
    sortable: true,
    type: 'Plain',
    width: 180,
    hide: true,
    enableRowGroup: true,
  },
  {
    headerName: 'Comfort & Convenience Package',
    field: 'lucidComfortAndConvenience',
    sortable: true,
    type: 'Plain',
    width: 200,
    enableRowGroup: true,
  },
  {
    headerName: 'Seats',
    field: 'lucidFrontSeating',
    sortable: true,
    type: 'Plain',
    width: 200,
    enableRowGroup: true,
  },
  {
    headerName: 'Suspension Damper',
    field: 'suspensionDamp',
    sortable: true,
    type: 'Plain',
    width: 200,
    hide: true,
    enableRowGroup: true,
  },
  {
    headerName: 'Battery pack',
    field: 'batteryPack',
    sortable: true,
    type: 'Plain',
    width: 140,
    hide: true,
    enableRowGroup: true,
  },
  {
    headerName: 'Current city',
    field: 'currentCity',
    sortable: true,
    type: 'Plain',
    width: 140,
    hide: false,
    enableRowGroup: true,
  },
  {
    headerName: 'Current State',
    field: 'currentState',
    sortable: true,
    type: 'Plain',
    width: 140,
    hide: false,
    enableRowGroup: true,
  },
  {
    headerName: 'Comments',
    field: 'prevAssgnChange.comments',
    type: 'Plain',
    width: 200,
    hide: false,
    enableRowGroup: true,
  },
  {
    headerName: 'In Transit To Location',
    field: 'inTransitToLocation',
    sortable: true,
    type: 'Plain',
    width: 140,
    hide: false,
    enableRowGroup: true,
  },
  {
    headerName: 'Title Status',
    field: 'titleStatus',
    sortable: true,
    type: 'Plain',
    width: 140,
    hide: true,
    enableRowGroup: true,
  },
  {
    headerName: 'Action',
    field: 'disabled',
    sortable: true,
    type: 'Action',
    width: 100,
    enableRowGroup: false,
  },
];

export const metaData = {
  _id: '6316fd3926673f830a4d64f7',
  module: 'Vehicles',
  subModule: 'Grid',
  columnDefs,
  filterDetails: [
    'Batch·Number',
    'vin',
    'Model',
    'Variant',
    'Vehicle Stage',
    'Vehicle Substage',
    'Country',
    'Current City',
    'Current State',
    'Assigned Customer',
    'Assignment Type',
    'Seats',
    'Comfort & Convenience Package',
    'Action',
  ],
  manageColumns: [
    'Batch Number',
    'VIN',
    'Year',
    'Model',
    'Variant',
    'Vehicle Stage',
    'Vehicle Substage',
    'Country',
    'Current City',
    'Current State',
    'Assigned Customer',
    'Assignment Type',
    'Seats',
    'Comfort & Convenience Package',
  ],
  langCode: 'en-us',
};
